export const sanitizeInput = (input: string) => {
  if (typeof input === "string") {
    return input.replace(/[<>"'`;*~\\[\]{}=]/g, "");
  }
};
